var React = require('react');

function Map (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.3"},React.createElement("path",{"d":"M16.0001 0C9.60976 0 4.41089 5.19887 4.41089 11.5891C4.41089 19.5196 14.7821 31.1621 15.2236 31.6538C15.6384 32.1157 16.3625 32.1149 16.7765 31.6538C17.2181 31.1621 27.5893 19.5196 27.5893 11.5891C27.5891 5.19887 22.3903 0 16.0001 0ZM16.0001 17.4199C12.785 17.4199 10.1693 14.8042 10.1693 11.5891C10.1693 8.374 12.785 5.75838 16.0001 5.75838C19.2151 5.75838 21.8308 8.37406 21.8308 11.5892C21.8308 14.8043 19.2151 17.4199 16.0001 17.4199Z","fill":"black"})));
}

Map.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Map;

Map.default = Map;
